/**
 * The merge ladder, low to high: a merge always produces the symbol one step to the right, and `FS` (the scatter) is
 * the terminus. The grid's nine symbol ids, in the order the ladder bar shows them.
 */
export const MERGE_LADDER = ["L1", "L2", "L3", "L4", "H1", "H2", "H3", "H4", "FS"] as const;

export type LadderSymbolId = (typeof MERGE_LADDER)[number];

/** The scatter: it lands, merges out of `H1` and `H4` clusters, and never pays or merges itself. */
export const SCATTER_SYMBOL_ID: LadderSymbolId = "FS";

/**
 * The Secret Bonus symbol: off the ladder, it never pays or merges; the server lands it on a base spin's last board,
 * where a tap on it offers its bonus until the next spin (decision 51).
 */
export const SECRET_BONUS_SYMBOL_ID = "SB";
